import { AssistantBase } from '@langchain/langgraph-sdk';

import {
  useGraphAssistant,
  useGraphAssistantsCreate,
  useGraphAssistantsUpdate,
} from '../../api/assistants';
import { useAssistantStore } from '../../store/assistants/assistantsStore';
import { useSelectAssistant } from './useSelectAssistant';

export const useSaveOrCreateAssistant = ({
  assistantId,
  value,
  save = false,
}: {
  assistantId?: string;
  value: Partial<AssistantBase>;
  save: boolean;
}) => {
  const activeAssistantId = useAssistantStore(
    (state) => state.activeAssistantId
  );
  // if user clicks "new" button, assistantId is undefined, so use the active assistant id
  const assistantIdToUse = assistantId ?? activeAssistantId;
  const { data: assistant } = useGraphAssistant(assistantIdToUse);
  const graphId = assistant?.graph_id;
  const { onSelectAssistant } = useSelectAssistant({
    graphId,
  });
  const setStagedAssistant = useAssistantStore(
    (state) => state.setStagedAssistant
  );

  const {
    trigger: createAssistant,
    isMutating: isCreatingAssistant,
    error: createAssistantError,
  } = useGraphAssistantsCreate(graphId ? { graphId } : null);

  const {
    trigger: saveAssistant,
    isMutating: isSavingAssistant,
    error: saveAssistantError,
  } = useGraphAssistantsUpdate(
    assistantId && graphId ? { assistantId, graphId } : null
  );

  const doSave = async () => {
    if (!save) {
      const assistant = await createAssistant({
        name: value.name,
        config: value.config,
      });
      return assistant;
    } else {
      const newAssistant = await saveAssistant({
        ...value,
      });
      return newAssistant;
    }
  };

  const saveOrCreateAssistant = async () => {
    const newAssistant = await doSave();
    if (!newAssistant) return;
    setStagedAssistant(undefined);
    onSelectAssistant({ assistant: newAssistant, activate: true });
  };

  return {
    saveOrCreateAssistant,
    isSavingAssistant,
    isCreatingAssistant,
    createAssistantError,
    saveAssistantError,
  };
};
